
import OpinionApi from './src/OpinionResources'
import ContentCollectApi from './src/ContentCollect'



let apis = {
   OpinionApi,
   ContentCollectApi
};

export default apis;
